import React from 'react';
import { useInView } from 'react-intersection-observer';

import { DEFAULT_OBSERVER_OPTIONS } from '../../constants/ovserver';
import { cn } from '../../utils/classname';
import './card.scss';

type CardProps = {
  content: any;
  icon: any;
  className: string;
  afterContent?: any;
  density?: 'small' | 'medium' | 'large';
  border?: 'medium' | 'large';
  reverted?: boolean;
  column?: boolean;
  animation?: 'default' | 'horizontal' | 'none';
};

export const Card: React.FC<CardProps> = ({
  icon,
  content,
  animation,
  density,
  border,
  afterContent,
  reverted,
  column,
  className,
  ...otherProps
}) => {
  const { ref, inView, entry } = useInView(DEFAULT_OBSERVER_OPTIONS);

  return (
    <div
      ref={ref}
      className={cn(
        'rc-card-wrapper',
        inView && `rc-card-wrapper--animated-${animation}`,
        `rc-card-wrapper--density-${density}`,
        `rc-card-wrapper--border-${border}`,
        className
      )}
      {...otherProps}
    >
      <div className={cn('rc-card', reverted && 'rc-card--reverted', column && 'rc-card--column')}>
        <div className="rc-card-icon">{icon}</div>
        <div className="rc-card-content">{content}</div>
      </div>
      {afterContent}
    </div>
  );
};

Card.defaultProps = {
  border: 'medium',
  density: 'medium',
  animation: 'default'
};
